export default __webpack_public_path__ + "static/media/2_3-thumbnail-chip-right.0f3205c0.png";